/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SSRV2RuleFormDataTravelDateRestriction
 */
export interface SSRV2RuleFormDataTravelDateRestriction {
    /**
     * 
     * @type {Date}
     * @memberof SSRV2RuleFormDataTravelDateRestriction
     */
    from?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof SSRV2RuleFormDataTravelDateRestriction
     */
    to?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof SSRV2RuleFormDataTravelDateRestriction
     */
    exclude?: boolean;
}

export function SSRV2RuleFormDataTravelDateRestrictionFromJSON(json: any): SSRV2RuleFormDataTravelDateRestriction {
    return SSRV2RuleFormDataTravelDateRestrictionFromJSONTyped(json, false);
}

export function SSRV2RuleFormDataTravelDateRestrictionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SSRV2RuleFormDataTravelDateRestriction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'from': !exists(json, 'from') ? undefined : (json['from'] === null ? null : new Date(json['from'])),
        'to': !exists(json, 'to') ? undefined : (json['to'] === null ? null : new Date(json['to'])),
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
    };
}

export function SSRV2RuleFormDataTravelDateRestrictionToJSON(value?: SSRV2RuleFormDataTravelDateRestriction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'from': value.from === undefined ? undefined : (value.from === null ? null : value.from.toISOString()),
        'to': value.to === undefined ? undefined : (value.to === null ? null : value.to.toISOString()),
        'exclude': value.exclude,
    };
}


